import * as React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

const DropdownMenuLink = ({ children, to, onClick }) => {
  return (
    <Link
      className={
        'indent-8 lg:indent-0 py-3 text-gray-600 lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700'
      }
      to={to}
      onClick={onClick}
    >
      {children}
    </Link>
  )
}

DropdownMenuLink.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
}

export default DropdownMenuLink
